export enum ManageUsersTabs {
  Invites = 'Invites',
  Participants = 'Participants',
}
